export default __webpack_public_path__ + "static/media/picMarcusLeng.aea3c040.png";